var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDea({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2745 13.5596L10.3945 15.4396",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2745 15.4396L10.3945 13.5596",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10573 8.74634C8.03906 8.73967 7.95906 8.73967 7.88573 8.74634C6.29906 8.69301 5.03906 7.39301 5.03906 5.79301C5.03906 4.15967 6.35906 2.83301 7.99906 2.83301C9.6324 2.83301 10.9591 4.15967 10.9591 5.79301C10.9524 7.39301 9.6924 8.69301 8.10573 8.74634Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99922 16.0395C6.78589 16.0395 5.57922 15.7328 4.65922 15.1195C3.04589 14.0395 3.04589 12.2795 4.65922 11.2061C6.49255 9.97947 9.49922 9.97947 11.3326 11.2061",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDea);
export default __webpack_public_path__ + "static/media/dea.1fbd2f47ff36ac7c9be78084bafcc181.svg";
export { ForwardRef as ReactComponent };